<ng-container *ngIf="speaker">
  <div class="p-16 border-2 border-gray-light">
    <div class="md:grid grid-cols-12">
      <div class="mb-32 md:mb-0 col-span-4">
        <div class="px-32">
          <app-persona [persona]="speaker"></app-persona>
        </div>
      </div>
      <div class="col-span-8">
        <div class="min-h-full md:pl-32 md:border-l-2 border-gray-light">
          <div class="prose mb-20" *ngIf="speaker.bio">
            {{ speaker.bio }}
          </div>
          <!-- <ng-container *ngIf="sessions">
            <ul>
              <ng-container *ngFor="let session of sessions; let i = index">
                <li>
                  <app-session
                    [session]="session"
                    [showDescription]="true"
                    [showPersona]="false"
                  >
                  </app-session>
                  <app-hr *ngIf="i < sessions.length - 1"></app-hr>
                </li>
              </ng-container>
            </ul>
          </ng-container> -->
        </div>
      </div>
    </div>
  </div>
</ng-container>
